import { useEffect, useState, useCallback } from "react";
import { api, yen, paymentLabel } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { ReceiptDialog } from "../components/ReceiptDialog";
import { Badge } from "../components/ui/badge";

export default function Riwayat() {
  const { t } = useI18n();
  const [orders, setOrders] = useState([]);
  const [sel, setSel] = useState(null);

  const load = useCallback(
    () => api.get("/orders", { params: { limit: 200 } }).then(({ data }) => setOrders(data)),
    []
  );
  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="p-6 lg:p-8 space-y-6">
      <div>
        <h1 className="font-display text-3xl font-semibold">{t("riwayat_title")}</h1>
        <p className="text-sm text-muted-foreground">{t("riwayat_sub")}</p>
      </div>
      <div className="space-y-3">
        {orders.length === 0 && (
          <p className="text-muted-foreground text-sm">{t("no_tx")}</p>
        )}
        {orders.map((o) => (
          <button
            key={o.id}
            data-testid={`order-row-${o.id}`}
            onClick={() => setSel(o)}
            className="w-full text-left bg-white border border-gray-200 rounded-2xl p-4 flex items-center justify-between gap-4 hover:-translate-y-0.5 hover:shadow-md transition-all duration-200"
          >
            <div className="min-w-0">
              <p className="font-medium">
                {o.order_no}{" "}
                <span className="text-muted-foreground text-sm">
                  · {o.order_type === "dine_in" ? o.table_name || t("dine_in") : t("retail")}
                </span>
              </p>
              <p className="text-xs text-muted-foreground">
                {new Date(o.paid_at || o.created_at).toLocaleString("id-ID")} ·{" "}
                {o.items.length} {t("items")}
                {o.cashier_name ? ` · Kasir: ${o.cashier_name}` : ""}
              </p>
            </div>
            <div className="text-right shrink-0">
              <p className="num text-lg font-semibold">{yen(o.total || o.subtotal)}</p>
              <Badge variant={o.status === "paid" ? "secondary" : "default"}>
                {o.status === "paid" ? t(`pm_${o.payment_method}`) : t("unpaid")}
              </Badge>
            </div>
          </button>
        ))}
      </div>
      <ReceiptDialog order={sel} onClose={() => setSel(null)} />
    </div>
  );
}
